import { BottomOrRegularModal, Button, Input } from '@popsure/dirty-swan';
import NextImage from 'next/image';
import { useState } from 'react';

import { FamilyInputDataMap, FamilyQuoteData, PriceData } from '../../model';
import { submitPrivatePreSignupQuestionnaire } from './api';
import emailSvg from './assets/email.svg';
import styles from './SaveQuoteModal.module.scss';

export const SaveQuoteModal = ({
  isOpen,
  onClose,
  mainPriceData,
  spousePriceData,
  childrenPriceDataArr,
  familyMap,
  calculatorParams,
}: {
  isOpen: boolean;
  onClose: () => void;
  familyMap: FamilyInputDataMap;
  mainPriceData?: PriceData;
  spousePriceData?: PriceData;
  childrenPriceDataArr?: PriceData[];
  calculatorParams?: string;
}) => {
  const [email, setEmail] = useState<string | undefined>();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const valid = (email?.length ?? 0) > 0;

  const mainQuoteData: FamilyQuoteData[] = mainPriceData
    ? [
        {
          name: 'You',
          price:
            mainPriceData.discountedMonthlyPrice ??
            mainPriceData.monthlyPrice ??
            0,
          planStr: mainPriceData.planStr,
        },
      ]
    : [];

  const spouseQuoteData: FamilyQuoteData[] = spousePriceData
    ? [
        {
          name: 'Spouse',
          price:
            spousePriceData.discountedMonthlyPrice ??
            spousePriceData.monthlyPrice ??
            0,
          planStr: spousePriceData.planStr,
        },
      ]
    : [];

  const childrenQuoteData =
    childrenPriceDataArr?.map((priceData) => ({
      name: 'Child',
      price: priceData?.discountedMonthlyPrice ?? priceData?.monthlyPrice ?? 0,
      planStr: priceData?.planStr,
    })) ?? [];

  const familyQuoteDataArray: FamilyQuoteData[] = [
    ...mainQuoteData,
    ...spouseQuoteData,
    ...childrenQuoteData,
  ];

  const calculatorInputArray = Array.from(familyMap.entries());

  return (
    <BottomOrRegularModal
      title="Save this quote"
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setError('');
      }}
    >
      <NextImage
        className="mt24 ml-auto mr-auto d-block"
        src={emailSvg}
        alt="letter with a purple background"
      />
      <form
        className={`px24 pb24 ${styles.container}`}
        onSubmit={async (e) => {
          e.preventDefault();
          if (email) {
            setSubmitting(true);
            await submitPrivatePreSignupQuestionnaire({
              email,
              familyQuoteDataArray,
              calculatorInputArray,
              calculatorParams,
            });
            setSubmitting(false);
            onClose();
          }
        }}
      >
        <Input
          className="mt16"
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <p className="p-p--small mt8">
          We will be able to locate your quote if you reach out to our experts.
          No unsolicited emails.
        </p>
        {error && <div className="p-notice--danger mt24">{error}</div>}
        <Button className="mt16 w100" disabled={!valid} loading={submitting}>
          Send by email
        </Button>
      </form>
    </BottomOrRegularModal>
  );
};
